@if (show) {
  <figure class="figure">
    <img
      class="figure-img img-fluid rounded"
      alt=""
      [width]="params.width"
      [height]="params.height"
      [src]="params.value ?? 'assets/images/no-preview.jpg'"
    />
  </figure>
}
